import { isEqual } from 'lodash-es'
import { DayPlan as BackendDayPlan } from '@longtail-education/superprepstudy-data-model-frontend'
import { DateOnly } from '@nx-superprep/utils'

/**
 * Represents a day plan, extending the backend day plan model.
 */
export class DayPlan extends BackendDayPlan {
  /** The date represented as DateOnly object. */
  dateOnly: DateOnly

  /**
   * Constructs a new instance of DayPlan.
   * @param options An object containing optional properties to initialize the day plan.
   */
  constructor(options: Partial<DayPlan> = {}) {
    super(options.userId ?? '', new DateOnly(options.date).toTimestamp())
    this.dateOnly = new DateOnly(options.date)
    this.id = options.id
    this.progress = Number(options.progress) || 0
    this.highestCorrectStreak = Number(options.highestCorrectStreak) || 0
    this.finishedModuleCount = Number(options.finishedModuleCount) || 0
    this.inprogressModuleCount = Number(options.inprogressModuleCount) || 0
    this.todoModuleCount = Number(options.todoModuleCount) || 0
    this.estimatedCompletionTime = Number(options.estimatedCompletionTime) || 0
    this.actualStudyTime = Number(options.actualStudyTime) || 0
    this.acquisitionTarget = Number(options.acquisitionTarget) || 0
    this.acquisitionProgress = Number(options.acquisitionProgress) || 0
    this.reviewTarget = Number(options.reviewTarget) || 0
    this.reviewProgress = Number(options.reviewProgress) || 0
  }

  /**
   * Checks if two day plan objects are equal.
   * @param a The first day plan object.
   * @param b The second day plan object.
   * @returns True if the two day plan objects are equal, otherwise false.
   */
  static isEqual(a: DayPlan | undefined, b: DayPlan | undefined): boolean {
    return isEqual(a, b)
  }

  /**
   * Checks if this day plan object is equal to another day plan object.
   * @param other The other day plan object to compare.
   * @returns True if this day plan object is equal to the other object, otherwise false.
   */
  isEqual(other: DayPlan | undefined): boolean {
    return DayPlan.isEqual(this, other)
  }

  get isComplete() {
    return this.todoModuleCount === 0 && this.inprogressModuleCount === 0 && this.finishedModuleCount > 0
  }
}
